import { render, staticRenderFns } from "./DownloadAttachFile.vue?vue&type=template&id=33fcf5f4&"
import script from "./DownloadAttachFile.vue?vue&type=script&lang=js&"
export * from "./DownloadAttachFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttachFile.vue?vue&type=style&index=0&id=33fcf5f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports